import React, { useState, useEffect } from 'react'

type Props = {
  delay?: number,
  children: React.ReactNode
}

const DelayComponent = (props: Props) => {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true)
    }, props.delay ?? 300)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  return <React.Fragment>{visible ? props.children : null}</React.Fragment>
}

export default DelayComponent